/**
 * React mount point for new UI (Three.js scenes, islands, etc.).
 * The existing portfolio HTML/CSS still drives the page; migrate sections here over time.
 *
 * Example:
 *   import ExampleThree from './components/ExampleThree.jsx';
 *   return <ExampleThree />;
 */
export default function App() {
  return null;
}
